const Autocomplete = () => {
    const inputPairs = [
        { input: "#vacancy-search", results: "#autocomplete-results" },
        { input: "#vacancy-search-small", results: "#autocomplete-results-small" },
    ];

    inputPairs.forEach(({ input, results }) => {
        const inputEl = document.querySelector<HTMLInputElement>(input);
        const resultsEl = document.querySelector(results);

        if (!inputEl || !resultsEl) {
            // Only log if one exists but not the other (optional)
            if (inputEl || resultsEl) {
                console.log(`Skipping autocomplete setup — one of the elements is missing:`, { inputEl, resultsEl });
            }
            return;
        }

        let timeout: NodeJS.Timeout;

        inputEl.addEventListener("input", () => {
            clearTimeout(timeout);

            timeout = setTimeout(async () => {
                const searchTerm = inputEl.value.trim();

                if (searchTerm.length === 0) {
                    resultsEl.innerHTML = "";
                    return;
                }

                try {
                    const response = await fetch(`/wp-json/public/v1/vacancies/titles?ss=${encodeURIComponent(searchTerm)}`);
                    if (!response.ok) throw new Error(`Status: ${response.status}`);

                    const data = await response.json();

                    if (!Array.isArray(data.titles) || data.titles.length === 0) {
                        resultsEl.innerHTML = "<li>No results were found.</li>";
                    } else {
                        resultsEl.innerHTML = data.titles
                            .map(({ title, permalink }) => `<li><a href="${permalink}">${title}</a></li>`)
                            .join("");
                    }
                } catch (err) {
                    console.error(`Autocomplete fetch failed for ${input}:`, err);
                }
            }, 300);
        });
    });
};

export { Autocomplete as default };



// const initAutocomplete = (inputSelector: string, resultsSelector: string) => {
//     const input = document.querySelector<HTMLInputElement>(inputSelector);
//     const resultsContainer = document.querySelector(resultsSelector);
//
//     if (!input || !resultsContainer) {
//         console.log(`Input or results container not found for: ${inputSelector}, ${resultsSelector}`);
//         return;
//     }
//
//     console.log(`Initializing autocomplete for: ${inputSelector}`);
//
//     let timeout: NodeJS.Timeout;
//
//     input.addEventListener("input", () => {
//         clearTimeout(timeout);
//
//         timeout = setTimeout(async () => {
//             const searchTerm = input.value.trim();
//
//             if (searchTerm.length === 0) {
//                 resultsContainer.innerHTML = "";
//                 return;
//             }
//
//             try {
//                 const response = await fetch(`/wp-json/public/v1/vacancies/titles?ss=${encodeURIComponent(searchTerm)}`);
//                 if (!response.ok) throw new Error("Network response was not ok");
//
//                 const data = await response.json();
//
//                 if (!Array.isArray(data) || data.length === 0) {
//                     resultsContainer.innerHTML = "<li>No results were found.</li>";
//                 } else {
//                     resultsContainer.innerHTML = data
//                         .map(({ title, permalink }) => `<li><a href="${permalink}">${title}</a></li>`)
//                         .join("");
//                 }
//             } catch (error) {
//                 console.error("Error fetching vacancy titles:", error);
//                 resultsContainer.innerHTML = "<li>Something went wrong.</li>";
//             }
//         }, 300);
//     });
// };
//
// const Autocomplete = () => {
//     const pairs: [string, string][] = [
//         ["#vacancy-search", "#autocomplete-results"],             // Desktop
//         ["#vacancy-search-small", "#autocomplete-results-small"]  // Mobile
//     ];
//
//     pairs.forEach(([inputSelector, resultsSelector]) => {
//         initAutocomplete(inputSelector, resultsSelector);
//     });
// };
//
// export { Autocomplete as default };

